import React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HC_exporting from 'highcharts/modules/exporting';
import Theme from "highcharts/themes/grid-light";
require("highcharts/modules/export-data")(Highcharts);
HC_exporting(Highcharts);
Theme(Highcharts);

const LineChartMini: any = (props: any) => {
	// console.log('props (isYAxisActive) :: ', props.isYAxisActive);
	const { allData, exportExcel, exportarImagen, labels, title, subtitle, idChart, activeButton, colores, formatDataStringData, numDecimalProps, pieTextProps, showPieTextInGraph, showSeries, isRevertGraphY, mostrarlegend, isThousandFormat } = props;
	function formatMilesChileno(number: any) {
		return number
			.toString()
			.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
	}
    const options = {
        chart: {
            type: 'spline',
            height: 300,
            width: 300,
            backgroundColor: '#ffffff'
        },
        title: {
            text: ''
        },
        subtitle: {
            text: ''
        },
     
		yAxis: {
			visible: props.isYAxisActive,
			minorGridLineWidth: 0,
			gridLineWidth: 0,
			title: "enabled"
			, reversed: isRevertGraphY,
			labels: {
				formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {

					if (isThousandFormat) {
						return formatMilesChileno(this.value) + (formatDataStringData ? formatDataStringData : '');
					}
					else {
						return this.value + (formatDataStringData ? formatDataStringData : '');
					}


	
				},
			}
		},
        xAxis: {
            gridLineWidth: 0,
            categories: labels,
            max: (labels.length - 1)
        },
        tooltip: {
            shared: true,
            useHTML: true,
            headerFormat: '<table><tr><th colspan="2">{point.key}</th></tr>',
            pointFormat: '<tr><td style="color: {series.color}">{series.name}: </td>' +
                '<td style="text-align: right"><b>{point.y}</b></td></tr>',
            footerFormat: '</table>',
            valueDecimals: 0
        },
        plotOptions: {
			series: {
				dataLabels: {
					formatter: function (this: Highcharts.PointLabelObject) {


						//@ts-ignore
						if (numDecimalProps === 0) {
							const vaar: any = this;
							//@ts-ignore
							if (isThousandFormat) {
								return formatMilesChileno(this.y) + (formatDataStringData ? formatDataStringData : '');
							}
							else {
								return vaar.y.toFixed(0) + (formatDataStringData ? formatDataStringData : '')
							}
							; // Mostrar sin decimales si es un número entero
						} else {

							const vaar: any = this;
							if (isThousandFormat) {
								return formatMilesChileno(this.y) + (formatDataStringData ? formatDataStringData : '');
							}
							else {
								return vaar.y.toFixed(numDecimalProps) + (formatDataStringData ? formatDataStringData : ''); // Mostrar con dos decimales en otros casos

							}
						}



					},
					align: 'right',
					enabled: showSeries,
					inside: false
				},
				grouping: true
			}
		},
        credits: {
            enabled: false
        },
        series: allData,
        colors: colores,
        legend: {
            enabled: true // Se muestra a todos line charts
        },
        exporting: {
            enabled: false
        }
    };

    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={options} />
        </>
    );
}

export default LineChartMini;